import { DefaultError, useMutation } from "@tanstack/react-query";
import { bulkUpdateFaqsList } from "../api/bulkUpdateFaqsList";
import { createFaq } from "../api/createFaq";
import {
  getFaqsListByFaqGroupQueryData,
  invalidateFaqsListByFaqGroupQuery,
} from "../queries/useFaqsListByFaqGroupQuery";
import { FaqDataToCreate } from "../types";

type Params = {
  faqGroupId: string;
  data: FaqDataToCreate;
};

export const useCreateFaqMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async ({ data, faqGroupId }) => {
      const prevData = getFaqsListByFaqGroupQueryData(faqGroupId);

      const dataToUpdate =
        prevData?.reduce((acc, faqData) => {
          if (faqData.order < data.order) {
            return acc;
          }

          return {
            ...acc,
            [faqData.id]: {
              order: faqData.order + 1,
            },
          };
        }, {}) ?? {};

      await Promise.all([
        createFaq(faqGroupId, data),
        bulkUpdateFaqsList(faqGroupId, dataToUpdate),
      ]);
    },
    onSuccess: (_, { faqGroupId }) => {
      invalidateFaqsListByFaqGroupQuery(faqGroupId);
    },
    onError: (e) => {
      console.error("Error occurred when creating faq", e);
    },
  });
};
